export enum TipoCliente {
  Cliente = 1,
  Parceiro,
}
